import { rootElement } from '@shared/setup';
import AiTools from '@cwd/AiTools/AiTools.vue';

const initAiTools = async () => {
    rootElement({
        name: 'AiTools', // pascal, camel & kebab-case are valid
        component: AiTools,
        vm: {},
        contextComponents: ['<div>Waiting...</div>'],
    });
};

initAiTools();
